exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* These are example-specific */\n\n.react-toggle {\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\nlabel,\n.label-text {\n  vertical-align: middle;\n  font-weight: normal;\n  margin-bottom: 0; /* override bootstrap */\n}\n\n.example {\n  margin-top: 36px;\n  margin-bottom: 36px;\n}\n\npre {\n  margin-top: 8px;\n}\n\n.custom-classname.react-toggle--checked .react-toggle-track {\n  background-color: #ab199f;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/docs/style.css
// module id = 196
// module chunks = 0